module.exports = __webpack_public_path__ + "static/img/15一种改进型印花机.3cd73758.jpg";